import { createContext } from "react";

const TermsChecked = createContext()

export default TermsChecked;